/**
 * Meta's WhatsApp Usernames rollout lets a customer hide their phone number. Those
 * customers arrive with a business-scoped user ID (BSUID) — "EG.1070034385706394" — in
 * contact_inbox.source_id, where a phone number used to be.
 *
 * Several views render a WhatsApp source_id AS the customer's phone. Stripping the
 * non-digits off a BSUID produces a plausible-looking 16-digit number that is not a phone
 * at all — and an agent who copies it into an ERP sales order ships a COD parcel to
 * nowhere. Anything that presents a source_id as a phone number must check this first.
 *
 * Mirrors Whatsapp::Identity::BSUID_PATTERN on the Rails side; keep the two in step.
 */
const BSUID_PATTERN = /^[A-Za-z]{2}\.(?:ENT\.)?[A-Za-z0-9]{1,128}$/;

export const isWhatsAppBsuid = value => BSUID_PATTERN.test(String(value ?? ''));

/**
 * The @username Meta sends for a phone-less customer — the only human-readable handle
 * that identifies them. Stored the same way the fork already stores Instagram handles.
 */
export const whatsAppUsernameHandle = additionalAttributes => {
  const username = additionalAttributes?.social_profiles?.whatsapp;
  return username ? `@${username}` : '';
};
